import { Outlet } from 'react-router';

export interface MonitorBetaParams extends Record<string, string | undefined> {
  eventSlug: string;
}

export function MonitorBetaView() {
  return <Outlet />;
}
